// ProjectsServiceProvider.tsx
import { getAll, getOne, create } from '../services/CRUDServiceProvider';
import { PaginatedResponse } from '../types/pagination';
import { Translated } from '../types/translated';
import { PaginationRequest } from '../types/pagination';

let url_path = 'projects';
let project_like_url_path = 'like';

export interface Section {
    image: string;
    title: Translated;
    short_description: Translated;
    long_description: Translated;
    ltr: boolean | true;
};

export interface Project {
    slug: string;
    title: Translated;
    logo: string | null;
    logo_dark: string | null;
    likes_count: number;
    short_description: Translated;
    long_description: Translated;
    sections?: Section[];
    status: string | null;
};

export const getAllProjects = async (pagination: PaginationRequest, image_size: string | undefined): Promise<PaginatedResponse<Project>> => {
    //console.log(token);
    console.log(url_path);
    try {
        const response = await getAll<any>(url_path, pagination, image_size);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getProject = async (slug: string, image_size: string | undefined): Promise<Project> => {
    try {
        const response = await getOne<any>(url_path, slug, image_size, undefined);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const likeProject = async (project: Project): Promise<Project> => {
    try {
        const response = await await create<any>(project_like_url_path, project, 'application/json');
        return response.data;
    } catch (error) {
        throw error;
    }
};
